// AI-generated cover gallery
// Each theme has 3 professionally generated covers

const THEME_IDS = ['forest', 'sand', 'lavender', 'ocean', 'rose', 'indigo', 'mint', 'graphite'];
const COVERS_PER_THEME = 3;

const COVER_NAMES = {
  forest: ['Хвойный туман', 'Папоротник', 'Кольца дерева'],
  sand: ['Песчаные дюны', 'Терракота', 'Дзен-сад'],
  lavender: ['Лавандовое поле', 'Лиловый мрамор', 'Ботаника'],
  ocean: ['Бирюзовые волны', 'Морской горизонт', 'Кораллы'],
  rose: ['Пионы', 'Розовый мрамор', 'Пудра'],
  indigo: ['Ночное небо', 'Глубина', 'Мандала'],
  mint: ['Эвкалипт', 'Мятный акварель', 'Монстера'],
  graphite: ['Бетон', 'Угольный пейзаж', 'Суми-э'],
};

export function getAICovers(themeId) {
  if (!themeId) return getAllAICovers();
  const names = COVER_NAMES[themeId] || [];
  return Array.from({ length: COVERS_PER_THEME }, (_, i) => ({
    id: `${themeId}_${i + 1}`,
    theme: themeId,
    name: names[i] || `Обложка ${i + 1}`,
    url: `/generated-covers/${themeId}_${i + 1}.png`,
  }));
}

export function getAllAICovers() {
  return THEME_IDS.flatMap(id => getAICovers(id));
}

export function getAICoverUrl(coverId) {
  return `/generated-covers/${coverId}.png`;
}
